var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { viewBox: "0 0 140 140", width: "16", height: "16" } },
    [
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M30.8,54.7c0,0,30-3.7,39-3.7s39.2,3.7,39.2,3.7c2.4,0,4.2-2.2,3.9-4.6l-7.8-35.3C104.2,7.7,96.6,4,90.9,8 l-7.3,5.2c-1.7,1.2-3.7,1.8-5.7,1.8H62c-2,0-4-0.6-5.7-1.8L48.9,8c-5.7-4-13.3-0.4-14.3,6.7L26.9,50C26.6,52.5,28.4,54.7,30.8,54.7z ",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M136.3,72.5C118,67,91,62,70,62c-23,0-49,5-66.3,10.5c-1.9,0.6-3.7,1.8-3.7,4V77c0,2.2,1.6,4,3.7,4 c0,0,53.9-4,66.3-4c10.5,0,66.3,4,66.3,4c2,0,3.7-1.8,3.7-4v-0.5C140,74.3,138.3,73.1,136.3,72.5z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M38.5,93.2c9,0,16.4,7.3,16.4,16.4s-7.3,16.4-16.4,16.4s-16.4-7.3-16.4-16.4S29.5,93.2,38.5,93.2 M38.5,85 C25,85,14,96,14,109.5s11,24.5,24.5,24.5s24.5-11,24.5-24.5S52.1,85,38.5,85L38.5,85z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M102.1,93.2c9,0,16.4,7.3,16.4,16.4s-7.3,16.4-16.4,16.4s-16.4-7.3-16.4-16.4S93.1,93.2,102.1,93.2 M102.1,85 c-13.6,0-24.5,11-24.5,24.5s11,24.5,24.5,24.5s24.5-11,24.5-24.5S115.7,85,102.1,85L102.1,85z",
        },
      }),
      _vm._v(" "),
      _c("polygon", {
        staticClass: "st0",
        attrs: { points: "81.8,103 58.4,103 58.4,113 81.8,113 81.8,103 " },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }